import type React from "react";
import type { JSX } from "react";

import { translate } from "app/filters/i18nFilter";
import type { EnrichmentType } from "app/pages/sales-intelligence/modules/enrichment/types/types";

import {
    SL_LOAD_LIST_HEADER_TEXT_REPLACE,
    SL_LOAD_LIST_HEADER_TEXT_UPLOAD,
} from "../../../translations/suppressionListKeys";
import type { ErrorTexts, ParsingErrors } from "../../types";
import { StyledClosePopup, StyledLoadList, StyledLoadListHeader } from "../style";

import { CSVFileInput } from "./CSVFileInput";
import { UploadInstructions } from "./UploadInstructions";

type UploadListProps = {
    handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClose?: (isEventTracked?: boolean) => void;
    isLoading: boolean;
    isReplace: boolean;
    hasParsingError: boolean;
    parsingErrors: ParsingErrors;
    errorTexts?: ErrorTexts;
    type?: EnrichmentType;
    title?: string | null;
    className?: string;
    customInstructions?: React.ReactNode;
    dataAutomation?: string;
    hasCloseBtn?: boolean;
    customHint?: string | JSX.Element;
    hintWidth?: number | string;
    hasCustomTracking?: boolean;
    hasHint?: boolean;
};

export const UploadCSV = ({
    handleFileChange,
    onClose,
    errorTexts,
    customInstructions,
    isLoading,
    isReplace,
    hasCloseBtn,
    hasParsingError,
    parsingErrors,
    title = SL_LOAD_LIST_HEADER_TEXT_UPLOAD,
    className,
    dataAutomation,
    customHint,
    hintWidth,
    hasCustomTracking,
    hasHint = true,
    type = "company",
}: UploadListProps) => {
    const headerText = isReplace ? SL_LOAD_LIST_HEADER_TEXT_REPLACE : title;

    const renderInstructions = customInstructions || <UploadInstructions />;

    return (
        <StyledLoadList className={className}>
            {headerText ? (
                <StyledLoadListHeader>
                    {translate(headerText)}
                    {hasCloseBtn ? (
                        <StyledClosePopup
                            type="flat"
                            iconSize="xs"
                            iconName="close"
                            onClick={onClose}
                        />
                    ) : null}
                </StyledLoadListHeader>
            ) : null}

            {renderInstructions}

            <CSVFileInput
                hasCustomTracking={hasCustomTracking}
                errorTexts={errorTexts}
                data-automation={dataAutomation}
                isLoading={isLoading}
                hasError={hasParsingError}
                parsingErrors={parsingErrors}
                onChange={handleFileChange}
                customHint={customHint}
                hintWidth={hintWidth}
                hasHint={hasHint}
                type={type}
            />
        </StyledLoadList>
    );
};
